import { useContext } from 'react';
import { AuthContext } from '../authContext/context';

export const usePermissions = () => {
  const { permissions, isSuperAdmin: isSuperAdminFlag } = useContext(AuthContext);

  // Check single permission
  const hasPermission = (category, permission) => {
    // Superadmin has all permissions
    if (isSuperAdminFlag) {
      return true;
    }
    
    if (!permissions || !permissions[category]) {
      return false;
    }
    return permissions[category][permission] || false;
  };

  // Check multiple permissions (AND logic)
  const hasAllPermissions = (permissionList) => {
    // Superadmin has all permissions
    if (isSuperAdminFlag) {
      return true;
    }
    
    if (!permissions || !permissionList || permissionList.length === 0) {
      return false;
    }
    
    return permissionList.every(({ category, permission }) => 
      hasPermission(category, permission)
    );
  };

  // Check multiple permissions (OR logic)
  const hasAnyPermission = (permissionList) => {
    // Superadmin has all permissions
    if (isSuperAdminFlag) {
      return true;
    }
    
    if (!permissions || !permissionList || permissionList.length === 0) {
      return false;
    }
    
    return permissionList.some(({ category, permission }) => 
      hasPermission(category, permission)
    );
  };

  // Check if user has any permission in a category
  const hasAnyCategoryPermission = (category) => {
    // Superadmin has all permissions
    if (isSuperAdminFlag) {
      return true;
    }
    
    if (!permissions || !permissions[category]) {
      return false;
    }
    
    return Object.values(permissions[category]).some(perm => perm === true);
  };

  // Get all permissions for a category
  const getCategoryPermissions = (category) => {
    if (!permissions || !permissions[category]) {
      return {};
    }
    
    return permissions[category];
  };

  // Check if user is super admin (has all permissions)
  const isSuperAdmin = () => {
    // Use the flag from context
    return isSuperAdminFlag || false;
  };

  return {
    permissions,
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
    hasAnyCategoryPermission,
    getCategoryPermissions,
    isSuperAdmin
  };
};